var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"h-100 layout--pdf"},[_c('sp-app-bar',{attrs:{"spNav":false}}),_c('transition',{attrs:{"name":"fade","mode":"out-in","duration":500}},[_c('v-main',{style:(_vm.mainStyles)},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }